<div class="main-view space-y-4 md:space-y-6">
  <div class="flex flex-wrap items-start gap-2">
    <div class="min-w-0 flex-1 space-y-1">
      <app-page-surface-header titleIcon="checks"
        [compact]="true"
        title="Edit rule package"
        [subtitle]="'Product #' + productId + ' · ' + country + ' · client #' + tenantId"
      />
    </div>
  </div>

  <p *ngIf="loading" class="px-1 text-sm text-gray-500 dark:text-gray-400">Loading current values…</p>
  <p *ngIf="error" class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-100" role="alert">{{ error }}</p>

  <ng-container *ngIf="!loading">
    <div class="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900/40 dark:bg-amber-950/30 dark:text-amber-100">
      <strong>Save &amp; publish</strong> applies these values to new sessions immediately.
      <strong>Save as draft</strong> stores them for later review without going live.
      Compliance-locked minimums are enforced on save.
    </div>

    <app-rule-config-editor
      [config]="config"
      [lockedKeys]="lockedKeys"
      [busy]="busy"
      [showPublish]="true"
      (validate)="onValidate($event)"
      (saveDraft)="onSaveDraft($event)"
      (savePublish)="onSavePublish($event)"
    ></app-rule-config-editor>

    <div
      *ngIf="preview"
      class="rounded-2xl border p-4 text-sm"
      [ngClass]="preview.is_valid
        ? 'border-emerald-200 bg-emerald-50 dark:border-emerald-900/40 dark:bg-emerald-950/30'
        : 'border-red-200 bg-red-50 dark:border-red-900/50 dark:bg-red-950/40'"
    >
      <p class="font-medium" [class.text-emerald-800]="preview.is_valid" [class.text-red-700]="!preview.is_valid">
        {{ preview.is_valid ? 'Valid — safe to save.' : 'Invalid — fix the items below.' }}
      </p>
      <ul *ngIf="!preview.is_valid" class="mt-1.5 list-disc pl-5 text-red-700 dark:text-red-300">
        <li *ngFor="let v of preview.compliance_violations">
          {{ v.parameter }} must be ≥ {{ v.required }} ({{ v.regulation }}) — you set {{ v.provided }}
        </li>
        <li *ngFor="let e of preview.validation_errors">{{ e }}</li>
      </ul>
    </div>
  </ng-container>
</div>
